// extracted by mini-css-extract-plugin
export var errorIcon = "_pt-1";
export var nameLogo = "_pt-0";